import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { EmpathyBlock } from './components/EmpathyBlock';
import { ProductMockup } from './components/ProductMockup';
import { BonusHeadline } from './components/BonusHeadline';
import { BonusSection } from './components/BonusSection';
import { Bonus2 } from './components/Bonus2';
import { Bonus3 } from './components/Bonus3';
import { Bonus4 } from './components/Bonus4';
import { TestimonialsSection } from './components/TestimonialsSection';
import { MidCTA } from './components/MidCTA';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
import { ExitIntentPopup } from './components/ExitIntentPopup';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  const [bump1Selected, setBump1Selected] = useState(false);
  const [bump2Selected, setBump2Selected] = useState(false);
  const [showUpsellPopup, setShowUpsellPopup] = useState(false);
  const BASE_PRICE = 14;
  const BUMP_PRICE = 9.87;
  const total = BASE_PRICE + (bump1Selected ? BUMP_PRICE : 0) + (bump2Selected ? BUMP_PRICE : 0);
  const dollarSign = '\u0024';
  const displayTotal = total % 1 === 0 ? dollarSign + total : dollarSign + total.toFixed(2);
  // Build dynamic Shopify cart URL based on bump selections
  const buildCheckoutUrl = () => {
    if (bump1Selected && bump2Selected) {
      return 'https://www.shopdilore.com/cart/53920276414774:1';
    }
    if (bump1Selected) {
      return 'https://www.shopdilore.com/cart/53920203079990:1';
    }
    if (bump2Selected) {
      return 'https://www.shopdilore.com/cart/53920239649078:1';
    }
    return 'https://www.shopdilore.com/cart/53793048920374:1';
  };
  const checkoutUrl = buildCheckoutUrl();
  // Intercept checkout: show upsell popup if no bumps selected
  const handleBeforeCheckout = (): boolean => {
    if (!bump1Selected && !bump2Selected) {
      setShowUpsellPopup(true);
      return false; // prevent navigation
    }
    return true; // allow navigation
  };
  const handleUpsellAccept = () => {
    setShowUpsellPopup(false);
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
    window.open('https://www.shopdilore.com/cart/53967881208118:1', '_blank');
  };
  const handleUpsellDecline = () => {
    setShowUpsellPopup(false);
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
    window.open('https://www.shopdilore.com/cart/53793048920374:1', '_blank');
  };
  // Placeholder effect (original code masked)
  useEffect(() => {
    document.title = 'The Inherited House';
    // Set meta description
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'The step-by-step guide for overwhelmed heirs who need to know exactly what to do — without costly mistakes, family conflict, or months of confusion.';
  }, []);
  // Meta Pixel initialization - simplified and safer
  useEffect(() => {
    try {
      if (window.fbq) return;
      const fbq: any = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
        } else {
          fbq.queue.push(arguments);
        }
      };
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }
      window.fbq('init', '1604085974259940');
      window.fbq('track', 'PageView');
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1604085974259940&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    } catch (error) {
      console.error('Meta Pixel initialization error:', error);
    }
  }, []);
  return <main className="min-h-screen bg-warm-white selection:bg-accent selection:text-white" data-id="element-0">
      <div className="bg-navy-dark text-white text-center py-3 px-4 font-body text-sm md:text-base font-medium tracking-wide" data-id="element-1">
        If you inherited a house you have 30 days to act before the bank does.
        The Letter of Intent template is inside plus 7 Bank Call Scripts + The
        72 Hours House Lockdown Checklist + The Sell vs Rent Decision
        Calculator.
      </div>
      <HeroSection displayTotal={displayTotal} data-id="element-2" />
      <EmpathyBlock data-id="element-3" />
      <ProductMockup data-id="element-4" />
      <BonusHeadline data-id="element-5" />
      <BonusSection data-id="element-6" />
      <Bonus2 data-id="element-7" />
      <Bonus3 data-id="element-8" />
      <Bonus4 data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <MidCTA displayTotal={displayTotal} checkoutUrl={checkoutUrl} onBeforeCheckout={handleBeforeCheckout} data-id="element-11" />
      <GuaranteeSection bump1Selected={bump1Selected} setBump1Selected={setBump1Selected} bump2Selected={bump2Selected} setBump2Selected={setBump2Selected} displayTotal={displayTotal} data-id="element-12" />
      <FinalCTA bump1Selected={bump1Selected} setBump1Selected={setBump1Selected} bump2Selected={bump2Selected} setBump2Selected={setBump2Selected} displayTotal={displayTotal} checkoutUrl={checkoutUrl} onBeforeCheckout={handleBeforeCheckout} data-id="element-13" />
      <Footer data-id="element-14" />
      <RecentPurchaseToast data-id="element-15" />
      <ExitIntentPopup isOpen={showUpsellPopup} onAccept={handleUpsellAccept} onDecline={handleUpsellDecline} onClose={() => setShowUpsellPopup(false)} data-id="element-16" />
    </main>;
}